import React, { forwardRef } from "react";
import styled from "@emotion/styled";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import UIcon from "../../../lib/icons/untitled_ui/UIcon";

const Root = styled(CheckboxPrimitive.Root)(({ theme }) => ({
  width: 16,
  height: 16,
  flexShrink: 0,
  backgroundColor: theme.colors.sysBackgroundDefault,
  borderRadius: 4,
  borderWidth: 1,
  borderStyle: "solid",
  borderColor: theme.colors.sysBorderFunctional,

  "&[data-state=checked]": {
    backgroundColor: theme.colors.sysPrimaryDefault,
    borderColor: theme.colors.sysPrimaryDefault,
  },

  // Tri-state parents (`checked="indeterminate"`) fill like a checked box, with a dash
  // instead of a tick — Radix renders the indicator for this state too.
  "&[data-state=indeterminate]": {
    backgroundColor: theme.colors.sysPrimaryDefault,
    borderColor: theme.colors.sysPrimaryDefault,
  },

  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  "&:focus-visible": {
    outline: `2px solid ${theme.colors.sysPrimarySubtleAlt}`,
  },
  "&:hover:not(:disabled)": {
    borderColor: theme.colors.sysPrimaryHover,
    "&[data-state=checked]": {
      backgroundColor: theme.colors.sysPrimaryHover,
    },
    "&[data-state=indeterminate]": {
      backgroundColor: theme.colors.sysPrimaryHover,
    },
  },
}));

const CheckboxIndicator = styled(CheckboxPrimitive.CheckboxIndicator)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const Checkbox = forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ ...props }, ref) => (
  <Root ref={ref} {...props}>
    <CheckboxIndicator>
      <UIcon
        icon={props.checked === "indeterminate" ? "minus" : "checkOutlined"}
        size={12}
        color="sysTextWhite"
      />
    </CheckboxIndicator>
  </Root>
));

Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export default Checkbox;
